import { render, staticRenderFns } from "./ShowRequestType.vue?vue&type=template&id=08a1df90&"
import script from "./ShowRequestType.vue?vue&type=script&lang=js&"
export * from "./ShowRequestType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports